import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeleteRentalService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;;
  }

  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  getCombinedMonthlyBookings(vendorId): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/DeleteRental/GetCombinedMonthlyBookings?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetCombinedMonthlyOtherRentals(vendorId): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseURL}/DeleteRental/GetCombinedMonthlyOtherRentals?vendorId=` + vendorId,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  SaveDeleteCMonthlyRentals(rentalData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/DeleteRental/SaveDeleteCMonthlyRentals`;
    return this.http.post<any>(url, rentalData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  CanDisplaySaveAndRefund(): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseURL}/DeleteRental/CanDisplaySaveAndRefund`
    ).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
